import { render, staticRenderFns } from "./NvbbDrink.vue?vue&type=template&id=ec26c4c0&"
import script from "./NvbbDrink.vue?vue&type=script&lang=js&"
export * from "./NvbbDrink.vue?vue&type=script&lang=js&"
import style0 from "./NvbbDrink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports